import type { JSX } from 'react';
import { PortalHeader, SignOutMenu } from '@cca/ui';
import { signOutAllDevices } from './signout';

export function AuthLayout({
  children,
  showSignOut = false,
  headerExtra,
}: {
  children: React.ReactNode;
  showSignOut?: boolean;
  /** Extra control(s) rendered in the header beside Sign out (e.g. the
   *  registrar's Security pill) — keeps account plumbing out of the work area. */
  headerExtra?: React.ReactNode;
}): JSX.Element {
  // A fragment: PortalHeader owns the slot layout and its narrow-screen wrap (AUTH-1).
  const rightSlot =
    showSignOut || headerExtra ? (
      <>
        {headerExtra}
        {showSignOut && (
          <SignOutMenu
            onSignOut={() => {
              window.location.href = '/auth/logout';
            }}
            onSignOutAll={signOutAllDevices}
          />
        )}
      </>
    ) : undefined;

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--paper)',
      }}
    >
      <PortalHeader portalName="Vetting Portal" rightSlot={rightSlot} />
      <div
        style={{ flex: 1, maxWidth: 768, margin: '0 auto', width: '100%', padding: '40px 24px' }}
      >
        {children}
      </div>
      <footer
        style={{
          borderTop: '1px solid var(--border)',
          background: '#fff',
          padding: '14px 0',
          textAlign: 'center',
          fontSize: 11,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          color: 'var(--text2)',
        }}
      >
        CCAANZ Vetting Portal · {new Date().getFullYear()}
      </footer>
    </div>
  );
}
